import React, { Component } from "react";
import Slider from "react-slick";
import lodgingImg1 from '../img/Peak Thrills/lodging/(TNZ Newsroom) Matakauri Lodge  5 1.jpg';
import lodgingImg2 from '../img/Peak Thrills/lodging/PT_Lodging_2_WhareKeaLodge_2.png';
import lodgingImg3 from '../img/Peak Thrills/lodging/2 1.jpg';
import lodgingImg4 from '../img/Peak Thrills/lodging/PT_Lodging_4_Kelman-Hut_2.png';
import lodgingImg5 from '../img/Peak Thrills/lodging/PT_Lodging_5_Top-Hut_2.png';
import lodgingImg6 from '../img/Peak Thrills/lodging/(TNZ Newsroom) Media-Opening-Weekend-1 (1) 1.jpg';
import NextArrow from '../img/Arrow Right.png';
import PrevArrow from '../img/Arrow Left.png'

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block"}}
        onClick={onClick}><img className="arrow" src={NextArrow}/></div>
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}><img className="arrow" src={PrevArrow}/></div>
    );
  }

export default class SimpleSlider extends Component {
    state = {
        showPrevArrow: false,
      };
      handleAfterChange = (currentSlide) => {
        // Show previous arrow after the first slide
        if (currentSlide > 0) {
          this.setState({ showPrevArrow: true });
        } else {
          this.setState({ showPrevArrow: false });
        }
      };
  render() {
    const { showPrevArrow } = this.state;
    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: showPrevArrow ? <SamplePrevArrow /> : null, // Conditionally render the SamplePrevArrow component
        responsive: [
          {
            breakpoint: 1439,
            settings: {
              slidesToShow: 3
            }
          },
            {
              breakpoint: 980,
              settings: {
                slidesToShow: 1,
                variableWidth: false,
              }
            },
        ],
        afterChange: this.handleAfterChange, // Handle slide change event
    };
    return (
      <div className="lodging-carousel">
        <Slider {...settings} className="full-width-carousel">
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg1}/>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">1</h3>
                    <h3>Matakauri Lodge</h3> 
                    <p>Luxury lodging with panoramic views of the Remarkables amidst nearby peaks</p>
                    <p className="small-text light-italic location desktop">Farrycroft Row, 569 Glenorchy Road, <br/>Queenstown 9348, New Zealand</p>
                    <p className="small-text light-italic location sm-desktop">Farrycroft Row, 569 Glenorchy Road, Queenstown 9348, <br/>New Zealand</p>
                    <p className="small-text light-italic location mobile">Farrycroft Row, 569 Glenorchy Road, <br/>Queenstown 9348, New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg2}/>
                    <div className="copyright white">© Whare Kea Lodge</div>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">2</h3>
                    <h3>Whare Kea Lodge </h3> 
                    <p>A timeless retreat set against the dramatic backdrop of the Southern Alps</p>
                    <p className="small-text light-italic location desktop">494 Mount Aspiring Road, Wanaka 9343, <br/>New Zealand</p>
                    <p className="small-text light-italic location mobile">494 Mount Aspiring Road, Wanaka 9343, <br/>New Zealand</p>
                    <p className="small-text light-italic location sm-desktop">494 Mount Aspiring Road, Wanaka 9343, New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg3}/>
                    <div className="copyright white">© Dan Kelly</div>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">3</h3>
                    <h3>Kelly Hut </h3> 
                    <p>Fly in by helicopter to your 1880m-high lodge with winter activities at your doorstep</p>
                    <p className="small-text light-italic location desktop">Stewart Island / Rakiura, 9818, <br/>New Zealand</p>
                    <p className="small-text light-italic location mobile">Stewart Island / Rakiura, 9818, <br/>New Zealand</p>
                    <p className="small-text light-italic location sm-desktop">Stewart Island / Rakiura, 9818, New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg5}/>
                    <div className="copyright">© Mt Olympus</div>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">4</h3>
                    <h3>Top Hut, Mt Olympus</h3> 
                    <p>Stay near the action, with night-skiing and outdoor hot tubs for the adventurous lodger</p>
                    <p className="small-text light-italic location desktop">11220 Harper Road, Lake Coleridge<br/>Windwhistle, Canterbury, New Zealand</p>
                    <p className="small-text light-italic location mobile">11220 Harper Road, Lake Coleridge<br/>Windwhistle, Canterbury, New Zealand</p>
                    <p className="small-text light-italic location sm-desktop">11220 Harper Road, Lake Coleridge Windwhistle, Canterbury, New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg4}/>
                    <div className="copyright white">© Adventure Consultants</div>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">5</h3>
                    <h3>Kelman Hut </h3> 
                    <p>Perched right next to the Tasman Glacier for spectacular views unlike any other</p>
                    <p className="small-text light-italic location desktop">State Highway 5, Mangakakahi, Rotorua 3015, <br/>New Zealand</p>
                    <p className="small-text light-italic location mobile">State Highway 5, Mangakakahi, Rotorua 3015, <br/>New Zealand</p>
                    <p className="small-text light-italic location sm-desktop">State Highway 5, Mangakakahi, Rotorua 3015, New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg6}/>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">6</h3>
                    <h3>Cardrona Alpine Apartments </h3> 
                    <p>Stay at one of the few ski-in-ski-out resorts where you're minutes away from fun</p>
                    <p className="small-text light-italic location desktop">Cardrona Valley Road, Cardrona 9305, <br/>New Zealand</p>
                    <p className="small-text light-italic location mobile">Cardrona Valley Road, Cardrona 9305, <br/>New Zealand</p>
                    <p className="small-text light-italic location sm-desktop">Cardrona Valley Road, Cardrona 9305, New Zealand</p>
                </div>  
            </div> 
        </Slider>
      </div>
    );
  }
}